import ApiWebVone from "./apiWebVone";


function get(endPoint) {
    return ApiWebVone.get(endPoint)
        .then(res => {
            return res.data
        })
        .catch(err => {
            if (err.response) {
                return err.response;
            } else if (err.request) {
                return err.request;
            } else {
                return err.message;
            }
        });
}

function postWithBody(endPoint, body) {
    return ApiWebVone.post(endPoint,body)
        .then(res => {
            return res.data
        })
        .catch(err => {
            if (err.response) {
                return err.response;
            } else if (err.request) {
                return err.request;
            } else {
                return err.message;
            }
        });
}

function putWithFormData(endPoint, body) {
    return ApiWebVone.put(endPoint, body)
        .then(res => {
            return res.data
        })
        .catch(err => {
            if (err.response) {
                return err.response;
            } else if (err.request) {
                return err.request;
            } else {
                return err.message;
            }
        });
}


export default {
    get,
    postWithBody,
    putWithFormData
}